





































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import moment from 'moment';
import AbstractDisplayField from './abstract-display-field/abstract-display-field';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';

@Component({
  name: 'bpc-display-field-invoice-date-badge',
  components: {
    'bpc-drawer-modal': BpcDrawerModal,
    'bpc-std-form': StdForm,
  },
})
export default class DisplayFieldInvoiceDateBadge extends mixins(AbstractDisplayField) {
  public showForm = false;
  public showDrawerSection = false;

  get invoiceId(): number | null {
    if (this.item?.previous_renewal_invoice_id) {
      return this.item.previous_renewal_invoice_id;
    }

    return null;
  }

  get hasInvoiceToShow(): boolean {
    return (
      this.invoiceId !== null &&
      this.invoiceId !== undefined &&
      this.item?.previous_renewal_date !== null &&
      this.item?.previous_renewal_date !== undefined &&
      this.item?.previous_renewal_status !== null &&
      this.item?.previous_renewal_status !== undefined
    );
  }

  get formattedDate(): string {
    if (!this.hasInvoiceToShow || !this.value) return '';
    return moment(this.value).format('DD/MM/YYYY');
  }

  get variant(): string {
    const paymentStatus = this.item?.payment_status;
    const item = this.fieldConfig.valueToVariant?.find(item => item.value === paymentStatus);
    return item?.variant || this.fieldConfig.defaultVariant || 'info';
  }

  get valueLabel(): string {
    const paymentStatus = this.item?.payment_status;
    const item = this.fieldConfig.valueToLabel?.find(item => item.value === paymentStatus);
    return item?.label || item?.text || paymentStatus;
  }

  handleDateClick(): void {
    if (!this.hasInvoiceToShow) {
      return;
    }

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onDrawerClose(): void {
    this.showForm = false;
    this.showDrawerSection = false;
  }

  getModalTitle(): string {
    return this.$t('global.models.invoice.name').toString();
  }
}
